export default __webpack_public_path__ + "static/media/Calibri-Bold.d2362af0.TTF";